export function guessTimezone() {
  // Use Intl.DateTimeFormat to determine the guessed timezone
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return timezone || 'UTC'; // Default to UTC if not detected
}
